/* global Modernizr */
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import StageActions from '../../actions/StageActions';
import Link from '../utils/Link';

const propTypes = {
    onSceneChange: PropTypes.func.isRequired,
    // level: PropTypes.number,
    items: PropTypes.array,
};

const defaultProps = {
    // onClick: null,
    // level: 1,
    items: [
        {
            name: 'intro',
            route: '/',
            count: 9,
        },
        {
            name: 'remuneration',
            route: '/remuneration',
            count: 5,
        },
        {
            name: 'titrisation',
            route: '/titrisation',
            count: 5,
        },
        {
            name: 'titrisations',
            route: '/titrisations',
            count: 7,
        },
        {
            name: 'toobig',
            route: '/toobig',
            count: 3,
        },
        {
            name: 'regulation',
            route: '/regulation',
            count: 7,
        },
        {
            name: 'oligarchie',
            route: '/oligarchie',
            count: 9,
        },
    ],
};

const contextTypes = {
    store: PropTypes.object,
    pageKey: PropTypes.string,
    sceneKey: PropTypes.string,
    scenesCompleted: PropTypes.object,
    framesDone: PropTypes.object,
};

class StatusBar extends PureComponent {

    static onStopPropagation(e) {
        if (e) {
            e.preventDefault();
            e.stopPropagation();
        }
    }

    constructor(props) {
        super(props);
        this.renderStatusGroup = this.renderStatusGroup.bind(this);
        this.renderStatusItem = this.renderStatusItem.bind(this);
        this.onRouteChange = this.onRouteChange.bind(this);
    }

    componentWillMount() {
        const props = this.props;

        let total = 0;
        const counts = {};
        const names = [];

        for (let i = 0; i < props.items.length; i += 1) {
            const name = props.items[i].name;
            const count = props.items[i].count;
            counts[name] = count;
            names.push(name);
            total += count;
        }

        this.setState({
            segments: props.items.length,
            counts,
            names,
            total,
        });
    }

    onRouteChange(sceneKey) {
        if (this.props.onSceneChange !== null) {
            this.props.onSceneChange(sceneKey);
        }
    }

    renderStatusItem(item) {
        const { framesDone } = this.context;
        let active = item.active;
        if (framesDone && active === false) {
            active = framesDone[item.name] && framesDone[item.name][item.index];
        }

        const className = classNames({
            'status-bar-item': true,
            'status-bar-item active': active,
        });

        const style = {
            width: `${(100 / this.state.counts[item.name])}%`,
        };

        return (
            <div className={className} style={style} />
        );
    }

    renderStatusGroup(statusGroup, index) {
        const { names } = this.state;
        const items = [];
        const userEvents = {};

        let max = 0;
        for (let j = 0; j < names.length; j += 1) {
            if (typeof this.context.framesDone[names[j]] !== 'undefined') {
                max = j;
            }
        }

        for (let i = 0; i < statusGroup.count; i += 1) {
            items.push({
                name: statusGroup.name,
                index: i,
                active: index < max,
            });
        }

        const callback = (e) => {
            e.stopPropagation();
            this.onRouteChange(statusGroup.name);
        };

        if (Modernizr.touchevents) {
            userEvents.onTouchStart = StatusBar.onStopPropagation;
            userEvents.onTouchMove = StatusBar.onStopPropagation;
            userEvents.onTouchEnd = callback;
        } else {
            userEvents.onMouseDown = StatusBar.onStopPropagation;
            userEvents.onMouseMove = StatusBar.onStopPropagation;
            userEvents.onMouseUp = callback;
            userEvents.onWheel = StatusBar.onStopPropagation;
        }

        const style = {
            width: `${(100 / this.props.items.length)}%`,
        };

        return (
            <div className="status-bar-group" style={style} {...userEvents}>
                { items.map(this.renderStatusItem) }
            </div>
        );
    }

    render() {
        return (
            <div className="status-bar">
                { this.props.items.map(this.renderStatusGroup) }
                <div className="clear" />
            </div>
        );
    }
}

StatusBar.propTypes = propTypes;
StatusBar.defaultProps = defaultProps;
StatusBar.contextTypes = contextTypes;

module.exports = StatusBar;



// WEBPACK FOOTER //
// ./js/components/partials/StatusBar.jsx